import { ItemAliasType } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const itemAliasCreateAtom = createMutationAtomFactory(
  'settings.itemAliasCreate',
  (params: {
    itemId: string;
    accountId: string;
    aliasName: string;
    aliasCode?: string | null;
    aliasType: ItemAliasType;
    notes?: string | null;
  }) => ({
    tradeItemAliasCreate: {
      __args: {
        input: {
          itemId: params.itemId,
          accountId: params.accountId,
          aliasName: params.aliasName,
          aliasCode: params.aliasCode,
          aliasType: params.aliasType,
          notes: params.notes,
        },
      },
      id: true,
      aliasName: true,
      aliasType: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
